import { render, staticRenderFns } from "./QuoteTestBanner.vue?vue&type=template&id=4bfa46a2&"
import script from "./QuoteTestBanner.vue?vue&type=script&lang=ts&"
export * from "./QuoteTestBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports